import type { PageConfig_ComponentConfigFragment as PageConfigComponent } from 'bundles/page-config-common/queries/page-config/__generated__/PageConfigComponentsQuery';

// For eventing, we want to know the index of the collection when compared to other collection components.
const getEventingCollectionIndex = (
  currentCollectionId: string,
  pageConfigComponents: Array<PageConfigComponent | undefined | null>
) => {
  return pageConfigComponents
    ?.filter((component) => {
      return (
        (component?.__typename === 'PageConfig_CollectionComponent' &&
          !!component.collectionEntity &&
          (component.collectionEntity.__typename === 'Collection_Collection' ||
            component.collectionEntity.__typename === 'Recommendation_Collection') &&
          component.collectionEntity.entities &&
          component.collectionEntity.entities.elements?.length > 0) ||
        component?.__typename === 'PageConfig_PremiumCollectionComponent'
      );
    })
    .findIndex((component) => component?.id === currentCollectionId);
};

export default getEventingCollectionIndex;
